/**
 * <pre-order-banner> — pre-order / temporarily-unavailable banner.
 * The banner's visibility (collection membership) and the secondary line
 * (a block setting) are static/server-rendered. Only the bold headline
 * (sourced from each variant's special_message metafield) needs to react
 * to variant swaps.
 *
 * Setup lives in connectedCallback (not the constructor) and the whole file
 * is guarded against redeclaration — see assets/postcode-checker.js for why:
 * this theme's variant-change handling can reinsert a block's markup
 * (including its <script src> tags), and a classic script with top-level
 * class declarations throws a SyntaxError if it executes twice.
 */

if (!customElements.get('pre-order-banner')) {
  class PreOrderBanner extends HTMLElement {
    connectedCallback() {
      this.messageEl = this.querySelector('[data-special-message]');
      this.currentVariantId = parseInt(this.dataset.selectedVariantId, 10);

      const dataEl = document.getElementById(this.dataset.variantDataId);
      if (dataEl) {
        try {
          this.variants = JSON.parse(dataEl.textContent).variants;
        } catch (e) {
          console.error('Pre-order banner: failed to parse variant data', e);
        }
      }

      this.renderSpecialMessage(this.currentVariantId);
      this.subscribeToVariantChange();
    }

    disconnectedCallback() {
      if (this.unsubscribeVariantChange) this.unsubscribeVariantChange();
    }

    subscribeToVariantChange() {
      if (typeof FoxTheme === 'undefined' || !FoxTheme.pubsub) return;

      this.unsubscribeVariantChange = FoxTheme.pubsub.subscribe(
        FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
        (event) => {
          if (event.data.sectionId !== this.dataset.sectionId) return;
          if (!event.data.variant) return;

          this.currentVariantId = event.data.variant.id;
          this.renderSpecialMessage(this.currentVariantId);
        }
      );
    }

    renderSpecialMessage(variantId) {
      if (!this.messageEl) return;

      const variantData = (this.variants || []).find((v) => v.id === variantId);
      const specialMessage = (variantData && variantData.specialMessage) || 'Available for Pre Order';

      this.messageEl.textContent = specialMessage;
      this.messageEl.hidden = false;
    }
  }

  customElements.define('pre-order-banner', PreOrderBanner);
}
